import hatchPatternMapping from './hatchPattern'
import { getCompanyId } from '@/utils/getCompanyId'

const hatchProfileMapping = (data) => {
  const companyId = getCompanyId()
  return {
    name: data.name,
    company_id: companyId,
    description: data.description,
    hatch_patterns: hatchPatternMapping(data.hatch_patterns),
    id: data.id,
  }
}
export default hatchProfileMapping
